import { FC } from 'react';
import { Control, UseFormGetValues } from 'react-hook-form';
import { Column } from 'further-ui/components/Layout';
import { PeriodEndReportFormValues } from '../schema';
import GeneralOverviewMetrics from './GeneralOverviewMetrics';
import InvestmentFocus from './InvestmentFocus';
import FundMetrics from './FundMetrics';

type Props = {
  control: Control<PeriodEndReportFormValues>;
  readOnly: boolean;
  getValues: UseFormGetValues<PeriodEndReportFormValues>;
};

const FundOverviewDatapoints: FC<Props> = (props) => {
  const { readOnly } = props;

  return (
    <Column spacing={readOnly ? 'lg' : 'sm'}>
      <GeneralOverviewMetrics {...props} />
      <InvestmentFocus {...props} />
      <FundMetrics {...props} />
    </Column>
  );
};

export default FundOverviewDatapoints;
